export default {
  'billingSubscriptionPayments.description':
    'Revise los pagos manuales de suscripción pendientes y las suscripciones que requieren atención.',
  'billingSubscriptionPayments.claim.message': '¿Registrar un pago manual de suscripción?',
  'billingSubscriptionPayments.claim.hint':
    'Indique el importe recibido, la fecha del pago y la referencia externa. La moneda y el impuesto los define AUTOMY al confirmar.',
  'billingSubscriptionPayments.claim.submit': 'Enviar',
  'billingSubscriptionPayments.claim.lockedTitle': 'Este pago ya fue reportado y está en revisión.',
  'billingSubscriptionPayments.claim.evidencePlaceholder': 'Id de documento opcional',
  'billingSubscriptionPayments.claim.action': 'Registrar pago',
  'billingSubscriptionPayments.review.confirm.message': '¿Confirmar este pago manual?',
  'billingSubscriptionPayments.review.reject.message': '¿Rechazar este registro de pago?',
  'billingSubscriptionPayments.review.confirm': 'Confirmar pago',
  'billingSubscriptionPayments.review.reject': 'Rechazar registro',
  'billingSubscriptionPayments.review.reject.reasonPlaceholder':
    'Explique por qué se rechaza este registro de pago.',
  'billingSubscriptionPayments.review.discrepancyAck':
    'Confirmo que el bruto confirmado difiere del bruto reportado. Ambos valores permanecerán visibles.',
  'billingSubscriptionPayments.fields.provider': 'Proveedor',
  'billingSubscriptionPayments.fields.grossAmount': 'Bruto reportado',
  'billingSubscriptionPayments.fields.reportedGrossAmount': 'Bruto reportado',
  'billingSubscriptionPayments.fields.reportedPaymentDate': 'Fecha de pago reportada',
  'billingSubscriptionPayments.fields.reportedExternalReference': 'Referencia reportada',
  'billingSubscriptionPayments.fields.externalReference': 'Referencia externa',
  'billingSubscriptionPayments.fields.evidenceDocumentId': 'Documento de evidencia',
  'billingSubscriptionPayments.fields.notes': 'Notas',
  'billingSubscriptionPayments.fields.baseNetAmount': 'Base antes del descuento',
  'billingSubscriptionPayments.fields.discountAmount': 'Descuento',
  'billingSubscriptionPayments.fields.discountAssignmentId': 'Asignación de descuento',
  'billingSubscriptionPayments.fields.mrrAmount': 'MRR',
  'billingSubscriptionPayments.fields.noDiscount': 'Este cobro no tuvo descuento.',
  'billingSubscriptionPayments.sections.discountSnapshot': 'Descuento congelado en el pago',
  'billingSubscriptionPayments.fields.netAmount': 'Neto confirmado (subtotal)',
  'billingSubscriptionPayments.fields.taxAmount': 'Impuesto confirmado',
  'billingSubscriptionPayments.fields.confirmedGrossAmount': 'Bruto confirmado (total)',
  'billingSubscriptionPayments.fields.effectivePaymentDate': 'Fecha efectiva de pago',
  'billingSubscriptionPayments.fields.providerTaxReference': 'Referencia de autoridad fiscal',
  'billingSubscriptionPayments.fields.rejectionReason': 'Motivo de rechazo',
  'billingSubscriptionPayments.columns.company': 'Empresa',
  'billingSubscriptionPayments.columns.plan': 'Plan',
  'billingSubscriptionPayments.columns.netAmountDue': 'Neto adeudado',
  'billingSubscriptionPayments.columns.dueDate': 'Vencimiento',
  'billingSubscriptionPayments.columns.lastPaymentStatus': 'Último pago',
  'billingSubscriptionPayments.columns.reportedReference': 'Referencia reportada',
  'billingSubscriptionPayments.columns.confirmedReference': 'Referencia confirmada',
  'billingSubscriptionPayments.sections.reported': 'Registro reportado',
  'billingSubscriptionPayments.sections.confirmed': 'Pago confirmado',
  'billingSubscriptionPayments.tax.calculatedAtCheckout': 'Se calcula en el checkout',
  'billingPaymentProviderType.stripe': 'Stripe',
  'billingPaymentProviderType.bankTransfer': 'Transferencia bancaria',
  'billingPaymentProviderType.manual': 'Manual',
  'billingPaymentTransactionStatus.pending': 'Pendiente',
  'billingPaymentTransactionStatus.requiresAction': 'Requiere acción',
  'billingPaymentTransactionStatus.processing': 'En proceso',
  'billingPaymentTransactionStatus.paid': 'Pagado',
  'billingPaymentTransactionStatus.failed': 'Fallido',
  'billingPaymentTransactionStatus.cancelled': 'Cancelado',
  'billingPaymentTransactionStatus.refunded': 'Reembolsado',
  'billingPaymentTransactionStatus.partiallyRefunded': 'Reembolsado parcialmente',
  'global.text.billingSubscriptionPayments': 'Pagos de suscripción',
  'global.text.subscriptionSubtotal': 'Subtotal de suscripción (antes de impuestos)',
  'configList.hero.resource.billingSubscriptionPayments':
    'los pagos de suscripción que requieren atención',
  'configForm.hero.summary.resource.billingSubscriptionPayments.details':
    'del pago de suscripción seleccionado',
};
